import { Link } from 'react-router-dom';
import { testimonials, stats } from '@/mocks/testimonials';

export default function BrandSection() {
  return (
    <section id="about" className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-5">
          <p className="flex items-center gap-2 text-xs tracking-widest text-primary-600">
            <i className="ri-heart-3-line" aria-hidden="true"></i>
            ABOUT US
          </p>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950 leading-snug">
            我们只挑不扎心的
            <span className="text-primary-500">甜味瓜</span>
          </h2>
          <div className="mt-5 space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            <p>
              糖心吃瓜是一群喜欢看别人幸福的人做的小站。我们不追负面、不扒隐私，只把公开渠道里那些
              温柔的片段整理出来，做成一块可以随时来翻的甜瓜田。
            </p>
            <p>
              这里的每一条瓜都会标注整理时间与来源标签，编辑组坚持先读完再推荐。我们相信，娱乐内容也可以
              是让人放松、被治愈的东西，而不是另一种情绪消耗。
            </p>
          </div>
          <Link
            to="/about"
            className="mt-7 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            了解我们的内容原则
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="lg:col-span-7 flex flex-col gap-6">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            {stats.map((s) => (
              <div key={s.label} className="rounded-xl border border-background-200 bg-background-100 p-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className={`${s.icon} text-base`} aria-hidden="true"></i>
                </span>
                <p className="mt-3 font-heading text-lg text-foreground-950">{s.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-5"
              >
                <i className="ri-double-quotes-l text-2xl text-secondary-300" aria-hidden="true"></i>
                <blockquote className="mt-3 flex-1 text-sm text-foreground-700 leading-relaxed">{t.text}</blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-100 pt-4">
                  <div className="w-9 h-9 shrink-0 overflow-hidden rounded-full bg-background-200">
                    <img src={t.avatar} alt={`${t.name}的头像`} className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <p className="text-sm text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}